import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26c5a0fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-mod-timeline-indicator__portrait-label" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-mod-timeline-indicator__bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hd-mod-timeline-indicator__bar-thumb js-timeline-thumb" })
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "hd-mod-timeline-indicator__item-index" }
const _hoisted_5 = ["data-section"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass([
				'hd-mod-timeline-indicator',
				{ 'is-ready': _ctx.ready }
			])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_lyra_asset, {
          class: "hd-mod-timeline-indicator__portrait-label-title",
          "asset-key": `mod-timeline-label-${_ctx.activeSection}`
        }, null, 8, ["asset-key"])
      ]),
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: section.endpointId,
          class: _normalizeClass([
					'hd-mod-timeline-indicator__item',
					{ 'is-active': section.endpointId === _ctx.activeSection }
				])
        }, [
          _createElementVNode("div", {
            class: "hd-mod-timeline-indicator__item-content",
            onClick: ($event: any) => (_ctx.navigateToSection(section.endpointId))
          }, [
            _createVNode(_component_lyra_asset, {
              class: "hd-mod-timeline-indicator__item-title",
              "asset-key": `mod-timeline-label-${section.endpointId}`
            }, null, 8, ["asset-key"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(index + 1), 1)
            ]),
            _createElementVNode("div", {
              class: "hd-mod-timeline-indicator__item-thumb",
              "data-section": section.endpointId
            }, null, 8, _hoisted_5)
          ], 8, _hoisted_3)
        ], 2))
      }), 128))
    ], 2)
  ]))
}